import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/dashboard/Index"),
      children: [
        { path: "", redirect: "inicio" },
        {
          name: "Início",
          path: "inicio",
          component: () => import("@/views/dashboard/Inicio"),
        },
        {
          name: "Fluxo de Serviços Funerários",
          path: "fluxo-servico-funerario/:idAtendimento?",
          component: () => import("@/views/dashboard/FluxoServicoFunerario"),
        },
        {
          name: "Alocações",
          path: "fluxo-alocacoes",
          component: () => import("@/views/dashboard/FluxoAlocacoes"),
        },
        {
          name: "Fluxo de Serviços Cemiteriais",
          path: "fluxo-cemiterial",
          component: () => import("@/views/dashboard/FluxoServicoCemiterais"),
        },
        {
          name: "Fluxo Vaso",
          path: "fluxo-colocacao-vaso",
          component: () => import("@/views/dashboard/FluxoColocacaoVaso"),
        },
        {
          name: "Carnês devolvidos",
          path: "fluxo-carne-devolvidos",
          component: () => import("@/views/dashboard/FluxoCarneDevolvidos"),
        },
        {
          name: "Fluxo Cobrança",
          path: "fluxo-cobranca",
          component: () => import("@/views/dashboard/FluxoCobranca"),
        },
        {
          name: "Fluxo Vendas",
          path: "fluxo-vendas",
          component: () => import("@/views/dashboard/FluxoVendas"),
        },
        {
          name: "Documentação",
          path: "documentacao-servico-funerario",
          component: () => import("@/views/dashboard/DocumentacaoServicoFunerario"),
        },
        {
          name: "Controle de Acesso",
          path: "restrito",
          component: () => import("@/views/dashboard/Restrito"),
        },
      ],
    },
    {
      name: "Login",
      path: "/login",
      component: () => import("@/views/dashboard/Login"),
    },
    {
      name: "NotFound",
      path: "*",
      component: () => import("@/views/dashboard/Page404"),
    },
  ],
});
